import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import { TextInput } from '../Inputs/Inputs.jsx'
import AppDispatcher from '../../../dispatchers/AppDispatcher'
import styles from '../../../../css/devicePage.module.css'

const DeviceNumber = ({ device }) => {
  const [deviceNumber, setDeviceNumber] = useState(device.physical.deviceNumber)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        deviceNumber,
      },
    })
  }, [deviceNumber])

  useEffect(() => {
    appDispatch()
  }, [deviceNumber])

  const handleChange = useCallback((field, value, callback) => {
    setDeviceNumber(value)
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          Device Name
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <TextInput
            value={deviceNumber}
            childChange={childChange}
            field='deviceNumber'
          />
        </div>
      </section>
    </div>
  )
}

DeviceNumber.propTypes = {
  device: PropTypes.object.isRequired,
}

export default DeviceNumber
